export interface AlertState {
    showBlocked: boolean;
}

export const initialState: AlertState = {
    showBlocked: false,
};
